export default __webpack_public_path__ + "static/media/330_portfolio03-fr-mobile.594e5360.png";